import { useEffect, useState } from 'react';
import validator from 'validator';
import { Typography } from '../typography';
import { Button } from '../button';
import { Input, InputContainer } from '../input';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useUpdateInventoryItemMutation } from '../../hooks';
import { INPUT_ERRORS, MESSAGES } from '../../const';
import { i18n } from '../../i18n';
import { enqueueSnackbar } from '../snackbar';
import { containerValidator } from '../../utils';

export const inventoryItemUpdateModal: any = {};

export const InventoryItemUpdateModal = () => {
  const { mutate } = useUpdateInventoryItemMutation();
  const [open, setOpen] = useState(false);
  const [containerNumber, setContainerNumber] = useState('');
  const [comment, setComment] = useState('');

  const validators = {
    containerNumber:
      inventoryItemUpdateModal.status === 'EXTRA_FOUND'
        ? containerNumber
          ? !containerValidator(containerNumber)
            ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER
            : ''
          : INPUT_ERRORS.REQUIRED.CONTAINER_NUMBER
        : '',
    comment: comment
      ? !validator.isLength(comment, { min: 10, max: 200 })
        ? INPUT_ERRORS.NOT_VALID.COMMENT_LENGTH
        : ''
      : '',
  };

  useEffect(() => {
    inventoryItemUpdateModal.open = () => {
      setComment(inventoryItemUpdateModal.comment || '');
      setContainerNumber(
        inventoryItemUpdateModal.status === 'EXTRA_FOUND'
          ? inventoryItemUpdateModal.number || ''
          : '',
      );

      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(inventoryItemUpdateModal).forEach((key) => {
      if (key !== 'open') delete inventoryItemUpdateModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    if ([...Object.values(validators).map((val) => !val)].some((val) => !val)) {
      return;
    }

    const submitProps: any = {
      id: inventoryItemUpdateModal.id,
      yardId: inventoryItemUpdateModal.yardId,
      comment,
    };

    if (inventoryItemUpdateModal.status === 'EXTRA_FOUND') {
      submitProps.number = containerNumber;
    }

    mutate(submitProps, {
      onSuccess: () => {
        setOpen(false);
        enqueueSnackbar(MESSAGES.INVENTORY.SUCCESS.UPDATED, 'success');
        inventoryItemUpdateModal.submitClick();
      },
      onError: () => {
        enqueueSnackbar(MESSAGES.INVENTORY.ERROR.NOT_UPDATED, 'error');
      },
    });
  };

  return (
    <ModalBase id={'confirm-universal-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.inventoryItemUpdateTitle', {
            number: inventoryItemUpdateModal.number,
          })}
        </Typography>
        {inventoryItemUpdateModal.status === 'EXTRA_FOUND' && (
          <InputContainer
            id={'container-edit'}
            label={i18n.t('label.containerNumber') + '*'}
            data-size={'medium'}
            value={containerNumber}
            onChange={(e) => setContainerNumber(e.target.value)}
            error={!!validators.containerNumber}
            helperText={validators.containerNumber}
          />
        )}
        <Input
          label={i18n.t('label.comment')}
          data-size={'medium'}
          defaultValue={comment}
          onChange={(e) => setComment(e.target.value)}
          error={!!validators.comment}
          helperText={validators.comment}
          multiline
          rows={4}
        />
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.edit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
